import { Node } from '../lib/node';
import { DirectedWeightedEdge } from "./directed-weighted-edge";
import { FindPathSimpleDGBuilder } from "../specific/find-path-simple-dgbuilder";

/**
* The abstract class SimpleDirectedGraph extends the abstract 
* class Graph and describes the logical representation of a 
* simple directed graph. Simple directed graphs are directed 
* graphs that contain no loops. This class implements the abstract
* methods addEdge and deleteEdge, so that every edge is unidirectional. 
* 
* This class represents weighted simple directed graphs.
**/
export abstract class WeightedSimpleDirectedGraph extends FindPathSimpleDGBuilder {
    latestAddedEdge: DirectedWeightedEdge = null;


    //We set the weight of the least recent edge
    setWeight(weight: number){
        if(this.latestAddedEdge == null)
            return;
        
        this.latestAddedEdge.setWeight(weight);
        this.latestAddedEdge = null;
    }

    addEdge(from: Node, to: Node) {
        if (from == to)
            return;

        //Node has been deleted, hence cant be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1){
            return;
        }

        from.addNeighbor(to);
        if(!this.existsEdge(from,to)){
            let edge: DirectedWeightedEdge = new DirectedWeightedEdge(from,to);
            this.edges.push(edge);
            this.latestAddedEdge = edge;
        }
        this.update();

    }
   

    getEdge(fromNode: Node, toNode:Node): DirectedWeightedEdge{
        var searchEdge: DirectedWeightedEdge = null;
        this.edges.forEach(edge => {
             if (edge.getFromNode().getId() == fromNode.getId() && edge.getToNode().getId() == toNode.getId()) {
                 searchEdge = <DirectedWeightedEdge>edge;
             }
         });
         return searchEdge;
     }


}
